import templateStr from 'text!./templates/yes-no-group.html';

export default [function () {
    return {
        restrict: 'AE',
        template: templateStr,
        scope: {
            label: '@',
            model: '='
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/inputs/YesNoGroup.js
// module id = 782
// module chunks = 0